<template>
    <span>
        第
        <InputNumber v-model="index" style="width:40px" @on-change="changed" size='small'></InputNumber>
        <Select v-model="rowOrColumn" style="width:40px" @on-change="changed" size='small'>
            <Option value="row">行</Option>
            <Option value="column">列</Option>
        </Select>
    </span>
</template>
<script>
export default {
    props:["value", "data"],
    data() {
        return {
            rowOrColumn:"row",
            index:0
        }
    },
    watch: {
        value:{
            handler(v){
                if(v){
                    if(this.value.rowOrColumn!==undefined){
                        this.rowOrColumn = this.value.rowOrColumn;
                    }
                    if(this.value.index!==undefined){
                        this.index = this.value.index;
                    }
                }
            },
            immediate:true
        }
    },
    methods: {
        changed(){
            this.$emit("input", {
                rowOrColumn:this.rowOrColumn, 
                index:this.index
            })
            this.$emit("save");
        }
    },
}
</script>